module.exports = __webpack_public_path__ + "static/img/desert-road.838237a.jpg";